module.exports = __webpack_public_path__ + "assets/img/30.ea4cf022.png";